import common from './common.json'
import objectives from './objectives.json'
import home from './home.json'
import menu from './menu.json'
import devTools from './devTools.json'
import carbonOffsetConfiguration from './carbonOffsetConfiguration.json'
import assistanceConfiguration from './assistanceConfiguration.json'
import monConseillerPersoConfiguration from './monConseillerPersoConfiguration.json'
import additionalSales from './additionalSales.json'
import subscriptionTable from './subscriptionTable.json'
import subscriptionForm from './subscriptionForm.json'
import subscriptionTools from './subscriptionTools.json'
import servicesManagement from './admin/servicesManagement.json'
import organizationManagement from './admin/organizationManagement.json'
import providerOptionsManagement from './admin/providerOptionsManagement.json'
import officesManagement from './admin/officesManagement.json'
import usersManagement from './admin/usersManagement.json'
import ipAddressesManagement from './admin/ipAddressesManagement.json'
import additionalProductsManagement from './admin/additionalProductsManagement.json'
import auth from './auth.json'
import dashboard from './dashboard.json'
import clientCallbacks from './clientCallbacks.json'
import contractsTable from './contractsTable.json'

export default {
  home,
  objectives,
  common,
  menu,
  devTools,
  carbonOffsetConfiguration,
  additionalSales,
  subscriptionTable,
  subscriptionForm,
  subscriptionTools,
  servicesManagement,
  organizationManagement,
  providerOptionsManagement,
  usersManagement,
  ipAddressesManagement,
  additionalProductsManagement,
  auth,
  dashboard,
  assistanceConfiguration,
  monConseillerPersoConfiguration,
  officesManagement,
  clientCallbacks,
  contractsTable,
}
